import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { from, throwError } from 'rxjs';
import { switchMap, catchError, finalize } from 'rxjs/operators';
import { LoaderService } from '@core/services/loader.service';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { environment } from 'environments/environment';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
    const router = inject(Router);
    const msalService = inject(MsalService);
    const loader = inject(LoaderService);

    const activeAccount = msalService.instance.getActiveAccount();
    loader.show();
    return from(
        msalService.instance.acquireTokenSilent({
            account: activeAccount!,
            scopes: environment.APP_SCOPES,
        })
    ).pipe(
        switchMap(tokenResponse => {
            return next(req.clone({
                setHeaders: {
                    Authorization: `Bearer ${tokenResponse.accessToken}`,
                    'X-EVE-ORIGINATOR': 'null',
                    'X-EVE-CORRELATIONID': 'null'
                }
            }));
        }),
        catchError(error => {
            if (error instanceof InteractionRequiredAuthError) {
                console.warn("Token expired; sending 401 so route guard handles login");
                return throwError(() => error);
            }
            return throwError(() => error);
        }),
        finalize(() => {
            loader.hide();
        })
    );
};